import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import OrderList from '@shared/orders/OrderList'
import Can from '@shared/permissions/Can'

import { orderService } from '@services/operator/orderService'

const OperatorOrdersList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants, merchantShippingTypes } = useOperatorData()
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['orders', 'orders.list']}
        actions={
          <>
            <Can requiredPermission="orders:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="orders:write">
              <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/orders/new')}>
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <OrderList
        role="operator"
        service={orderService}
        merchants={merchants}
        shippingTypes={merchantShippingTypes}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}

export default OperatorOrdersList
